import { renderPage } from "renderPage"
import { UserSecurityLoginPage } from "./Page"

renderPage({ component: UserSecurityLoginPage })
